/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React, { Fragment, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { ROUTES } from '../../constants/routes';
import { generateUrl } from '../../routes/util';
import { ReportSwitcherContainer } from '../initiative/ReportSwitcherContainer';
import Dashboard, { DashboardRow } from '../dashboard';
import { CompanyInsightsSidebar } from '../../routes/summary/insights/partials/sidebar/CompanyInsightsSidebar';
import './styles.scss';

interface SummaryProps {
  initiativeId: string;
  surveyId?: string;
  isPortfolioTracker?: boolean;
  showReportSwitcher?: boolean;
  children?: React.JSX.Element | React.JSX.Element[];
  title?: string;
  className?: string;
  buttons?: React.JSX.Element[];
}

const Summary = (props: SummaryProps) => {
  const {
    initiativeId,
    className,
    children,
    isPortfolioTracker = false,
    showReportSwitcher = true,
    surveyId,
    title,
    buttons: initialButtons = [],
  } = props;

  const history = useHistory();

  const childrenArray = Array.isArray(children) ? children : [children];
  const buttons = [...initialButtons];

  const onReportChange = useCallback((surveyId: string) => {
    history.push(
      generateUrl(ROUTES.SUMMARY, { initiativeId, surveyId })
    );
  }, [history, initiativeId]);

  if (showReportSwitcher) {
    buttons.push(<ReportSwitcherContainer
      initiativeId={initiativeId}
      selectedSurveyId={surveyId}
      onChange={onReportChange}
    />);
  }

  const hasButtons = buttons.length > 0;
  return <>
    <Dashboard className={`profile-dashboard ${className}`} hasSidebar={true}>
      <CompanyInsightsSidebar alignButtonRow={hasButtons} isPortfolioTracker={isPortfolioTracker} />
      {hasButtons ? <DashboardRow className='topbar-container' title={title} buttons={buttons} mb={2} /> : null}
      <>{childrenArray.map((c, i) => c !== undefined ? <Fragment key={`profie-${i}`}>{c}</Fragment> : <></>)}</>
    </Dashboard>
  </>
};

export default Summary;
